// import { commerceI18nEnUs } from "@luigiclaudio/ga-baseline-ui/commerce";

const baselineUIMessagesEnUs = {
    // ...commerceI18nEnUs,
};

export default baselineUIMessagesEnUs;
